import { useState } from "react"
import {
  Flex,
  Text,
  Heading,
  Image,
  Collapse,
  Button,
  SimpleGrid,
} from "@chakra-ui/react"
import Document from "./Document"

const documente = [
  {
    text: "CG Asistenta de urgenta",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/CG-Asistenta-de-urgenta.pdf",
  },
]

const InstalatieElectricaSanitara = () => {
  const [expandedContent, setExpandedContent] = useState(false)
  const [hideButtonText, setHideButtonText] = useState("Afiseaza informatii")

  const handleHiddenContent = () => {
    if (expandedContent === true) {
      setExpandedContent(false)
      setHideButtonText("Afiseaza informatii")
    } else {
      setExpandedContent(true)
      setHideButtonText("Mai putine informatii")
    }
  }

  return (
    <Flex flexDirection="column" width="100%">
      <Flex flexDirection="column" alignItems="flex-start" width="100%">
        <Flex
          flexDirection="column"
          width="100%"
          alignItems={["center", "center", "center", "flex-start"]}
        >
          <Heading as="h5" size="sm">
            Iti punem la dispozitie specialisti pentru situatiile urgente de
            #Acasa, 24 de ore pe zi, 7 zile din 7!
          </Heading>
          <Flex
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            marginTop="16px"
          >
            <Flex
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              margin="16px"
            >
              <Image src="/cez-confort-asigurat/assets/plug.png" width="50px" />
              <Heading size="sm" as="h5" marginTop="16px">
                Servicii electrician
              </Heading>
              <Text fontSize="sm" marginTop="8px">
                Acopera avarii ale instalatiei electrice interioare, cum ar fi:
                prize, corpuri de iluminat fixe, scurtcircuit, sigurante,
                pericol de electrocutare;
              </Text>
            </Flex>
            <Flex
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              margin="16px"
            >
              <Image
                src="/cez-confort-asigurat/assets/water-tap.png"
                width="50px"
              />
              <Heading size="sm" as="h5" marginTop="16px">
                Servicii instalator
              </Heading>
              <Text fontSize="sm" marginTop="8px">
                Acopera reparatii la instalatia sanitara pentru: baterii de
                chiuveta si sisteme de scurgere, conducte, robineti;
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Text
            fontSize="sm"
            marginTop="8px"
            textAlign={["center", "center", "center", "left"]}
          >
            Serviciile sunt disponibile{" "}
            <strong>
              24 de ore pe zi/7 zile din saptamana/ 365(6) zile pe an (24/7/365)
            </strong>
            ;
          </Text>
          <Text
            fontSize="sm"
            marginTop="8px"
            textAlign={["center", "center", "center", "left"]}
          >
            <strong>Timpul mediu de deplasare a echipei de interventie</strong>{" "}
            la adresa solicitata in conditii normale meteorologice si de trafic,
            este de
            <strong> maxim 3 ore in mediul urban</strong> si{" "}
            <strong> maxim 4 ore in mediul rural</strong>, de la data
            inregistrarii apelului;
          </Text>
        </Flex>
        <Flex flexDirection="column" width="100">
          <Heading
            as="h4"
            size="sm"
            marginTop="8px"
            textAlign={["center", "center", "center", "left"]}
          >
            Criterii de eligibilitate
          </Heading>
          <Collapse in={expandedContent} width="100%">
            <Text
              marginTop="16px"
              fontSize="sm"
              textAlign={["center", "center", "center", "left"]}
            >
              Persoana fizica, titular al unui contract activ pentru furnizarea
              energiei electrice cu tarif{" "}
              <strong>CEZ Confort Asigurat Plus</strong>
            </Text>
            <Flex width="100%" flexDirection="column">
              <Heading
                as="h5"
                size="sm"
                marginTop="16px"
                marginBottom="16px"
                textAlign={["center", "center", "center", "left"]}
              >
                Evenimente acoperite
              </Heading>
              <Text
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
              >
                - Sunt acoperite avariile aparute in urma unei avarii
                accidentale survenite ca urmare a producerii unui eveniment
                neprevazut (imprevizibil, care a avut loc in ultimele 24 de ore)
                si intrerupe si/sau modifica mersul normal al lucrurilor. Nu
                sunt incluse activitati de mentenanta, intretinere sau revizii
                periodice;
              </Text>
              <Text
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
              >
                - Interventiile se efectueaza in limita a maximum 5
                interventii/an si un plafon/interventie de 450 de lei, dar nu
                mai mult de 1100 lei/an (TVA inclus);
              </Text>
            </Flex>
            <Heading
              as="h4"
              size="sm"
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              Documente
            </Heading>
            <SimpleGrid minChildWidth="100px" spacing="16px" marginTop="16px">
              {documente.map((document) => (
                <Document
                  key={document.text + document.url}
                  documentText={document.text}
                  documentUrl={document.url}
                />
              ))}
            </SimpleGrid>
          </Collapse>
        </Flex>
      </Flex>
      <Flex
        justifyContent="center"
        alignItems="center"
        marginBottom={["-24px", "-24px", "-24px", "-48px"]}
        marginTop="16px"
      >
        <Button onClick={() => handleHiddenContent()}>{hideButtonText}</Button>
      </Flex>
    </Flex>
  )
}

export default InstalatieElectricaSanitara
